import setResponseHeaders from '@buzzfeed/headers';
import { getRenderPageByName } from '../../upstreams/island-api';

import { CLUSTER } from '../../constants';
import { MAX_AGE_SHORT } from '../../constants/server';
import CreationLanderPage from '../../components/CreationLanderWeb';

const CREATION_LANDER_PAGE = {
  id: 471,
  name: 'creation__island__en-us__globalv3',
};

export async function getServerSideProps({ req, res }) {
  try {
    const page = await getRenderPageByName({ name: CREATION_LANDER_PAGE.name });

    const customKeys = [`feedapi:${CLUSTER}:page:${CREATION_LANDER_PAGE.id}`];

    setResponseHeaders({
      req,
      res,
      customKeys,
      maxAge: CLUSTER === 'prod' ? MAX_AGE_SHORT : 0,
      edition: 'en-us',
    });

    return {
      props: {
        page,
        isWeb: true,
        tracking: {
          context_page_id: 'create',
          context_page_type: 'feed',
        },
      },
    };
  } catch (error) {
    console.error(
      'getServerSideProps failed to complete execution on discover page'
    );
    console.error(error);
    throw error;
  }
}

export default CreationLanderPage;
